<div *ngIf="eachNotification" class="row align-items-center mb-1 flex-nowrap">
  <div class="col-3 col-xl-2 pe-0 min-width-fit">
    <priority-dots [importance]="groupImportance"></priority-dots>
  </div>
  <div class="col-5 col-xl-6 d-flex align-items-center justify-content-between px-1">
    <div class="">
      <div *ngIf="eventDetailsData" class="p-2 border border-rounded-05 d-inline-flex flex-column text-break event-details"
        [innerHTML]="eventDetailsData" [matTooltip]="detailsTooltip" matTooltipPosition="before"
        (click)="openModal()"
        >
      </div>
      <div *ngIf="extraDetails" class="text-break" [innerHTML]="extraDetails | safe: 'html'"></div>
    </div>
    <div *ngIf="zintLink" class="ms-2"><a [href]="zintLink" target="_blank" class="text-reset" [matTooltip]="zintLinkTooltip"><i class="fas fa-external-link"></i></a></div>
  </div>
  <div class="col-4 col-xl-4"><span class="comment">{{eachNotification.ruleDescription || ''}}</span></div>
</div>

<!-- summary modal -->
<div class="modal fade" [id]="'accountsSummaryModal__' + randomId" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-xl" role="document">
        <div *ngIf="accountsSummary" class="modal-content p-3"> 
        
            <ai-accounts-summaries [aiAccountSummary]="accountsSummary" [companyId]="companyNumber">
            </ai-accounts-summaries>  

        </div>
    </div>
    
</div>
